import React from 'react';
import { PartnerIcon, GoogleTrust } from './index';
import usePartnerLogo from './hooks/usePartnerLogo';

interface Props {
  withTrust?: boolean;
  logo?: string;
}

const PartnerLogo: React.FC<Props> = ({ withTrust, logo }) => {
  const { classes, withPartnerLogo } = usePartnerLogo(logo);

  return (
    <div className={classes.partner} data-cy="partner-logo">
      {withPartnerLogo && logo && <PartnerIcon logo={logo} />}
      {!withPartnerLogo && withTrust && <GoogleTrust />}
    </div>
  );
};

export default PartnerLogo;
